import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import MacbookAndIphone from '@propertypal/shared/src/resources/images/promote/premier-macbook-and-iphone.png';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import {
  Bg,
  CheckRow,
  CheckWrapper,
  Container,
  Content,
  LeftPanel,
  PromoImage,
  RightPanel,
  WideCheckRow,
  WideContainer,
  WidePromoImage,
} from './PropertyAd.style';

interface Props {
  slots: number;
}

const PropertyAd: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  if (props.slots === 2) {
    return (
      <WideContainer data-testid="wide-premium-ad">
        <LeftPanel>
          <h3>
            Make Your Property <span>Really Stand Out</span>
          </h3>

          <WidePromoImage src={MacbookAndIphone.src} />
        </LeftPanel>

        <RightPanel>
          <CheckWrapper>
            <WideCheckRow>
              <FontAwesomeIcon icon={faCheck} color={theme.primary} />
              Bigger Listing
            </WideCheckRow>

            <WideCheckRow>
              <FontAwesomeIcon icon={faCheck} color={theme.primary} />
              Larger Photos
            </WideCheckRow>

            <WideCheckRow>
              <FontAwesomeIcon icon={faCheck} color={theme.primary} />3 Additional Photos
            </WideCheckRow>

            <WideCheckRow>
              <FontAwesomeIcon icon={faCheck} color={theme.primary} />
              Enhanced Listing Until Sold
            </WideCheckRow>

            <WideCheckRow>
              <FontAwesomeIcon icon={faCheck} color={theme.primary} />
              Reach More Potential Buyers
            </WideCheckRow>

            <Link href="/promote/premier" prefetch={false}>
              <Button containerStyle={{ marginTop: 45 }}>Upgrade Your Property Listing</Button>
            </Link>
          </CheckWrapper>
        </RightPanel>
      </WideContainer>
    );
  }

  return (
    <Container data-testid="premium-ad">
      <Bg />

      <Content>
        <h3>
          Make Your Property <span>Really Stand Out</span>
        </h3>

        <PromoImage src={MacbookAndIphone.src} />

        <div>
          <CheckRow>
            <FontAwesomeIcon icon={faCheck} color={theme.primary} />
            Bigger Listing with Larger Photos
          </CheckRow>

          <CheckRow>
            <FontAwesomeIcon icon={faCheck} color={theme.primary} />
            Reach More Potential Buyers
          </CheckRow>

          <CheckRow>
            <FontAwesomeIcon icon={faCheck} color={theme.primary} />
            Enhanced Listing Until Sold
          </CheckRow>
        </div>

        <Link href="/promote/premier" prefetch={false}>
          <Button>Upgrade Your Property Listing</Button>
        </Link>
      </Content>
    </Container>
  );
};

export default PropertyAd;
